import { createAction } from '@reduxjs/toolkit';

export const openAddNewUserDialog = createAction(
  'projectUsers/openAddNewUserDialog'
);

export const closeAddNewUserDialog = createAction(
  'projectUsers/closeAddNewUserDialog'
);

export const openJoinEmployeeToProjectDialog = createAction(
  'projectUsers/openJoinEmployeeToProjectDialog'
);

export const closeJoinEmployeeToProjectDialog = createAction(
  'projectUsers/closeJoinEmployeeToProjectDialog'
);

export const setJoinEmployeeToProjectSelectedBusinessId = createAction(
  'projectUsers/setJoinEmployeeToProjectSelectedBusinessId'
);
